import { render, staticRenderFns } from "./sysStudentPerm.vue?vue&type=template&id=c607cd2e&scoped=true&"
import script from "./sysStudentPerm.vue?vue&type=script&lang=js&"
export * from "./sysStudentPerm.vue?vue&type=script&lang=js&"
import style0 from "./sysStudentPerm.vue?vue&type=style&index=0&id=c607cd2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c607cd2e",
  null
  
)

export default component.exports